
import React from 'react'

const WorkIcon = () => {
  return (
    <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.9281 13.899H13.9275V11.3594H12.0703V13.899V15.1689H13.9281V13.899Z" fill="#999FAC"/>
<path d="M15.1708 13.902V15.1719C15.1708 15.8722 14.6155 16.4417 13.9327 16.4417H12.0755C11.3927 16.4417 10.8374 15.8722 10.8374 15.1719V13.902H2.48028C2.03952 13.902 1.62228 13.8042 1.24219 13.6328V20.8861C1.24219 22.2867 2.35276 23.4258 3.71838 23.4258H22.2898C23.6554 23.4258 24.766 22.2867 24.766 20.8861V13.6328C24.3859 13.8036 23.9687 13.902 23.5279 13.902H15.1708Z" fill="#999FAC"/>
<path d="M22.9107 3.7449H17.9583V2.47507C17.9583 1.42491 17.1251 0.570312 16.1012 0.570312H9.91072C8.88681 0.570312 8.05357 1.42491 8.05357 2.47507V3.7449H3.10119C1.73557 3.7449 0.625 4.88394 0.625 6.28457V10.729C0.625 11.7791 1.45824 12.6337 2.48214 12.6337H10.8393V11.3639C10.8393 10.6636 11.3946 10.0941 12.0774 10.0941H13.9345C14.6173 10.0941 15.1726 10.6636 15.1726 11.3639V12.6337H23.5298C24.5537 12.6337 25.3869 11.7791 25.3869 10.729V6.28457C25.3869 4.88394 24.2763 3.7449 22.9107 3.7449ZM9.29167 3.7449V2.47507C9.29167 2.12523 9.569 1.84015 9.91072 1.84015H16.1012C16.4429 1.84015 16.7202 2.12523 16.7202 2.47507V3.7449H9.29167Z" fill="#999FAC"/>
</svg>
    
  )
}

export default WorkIcon
